<template>
    <b-modal :title="Core.Definition.getDefinition('Exporter sous format ...')" :hide-footer="true" v-model="dataShow">
        <Request
                ref="request"
                :root="root"
                :method="method"
                :onRequestSuccess="onRequestSuccess">
            <slot slot="body">
                <CForm
                        ref="form"
                        @onSubmit="onSubmit"
                        @onReset="onReset"
                        v-if="formStructure.rows !== undefined"
                        :options=" {
                            submit: {
                                text: Core.Definition.getDefinition('Exporter'),
                                variant: 'success'
                            },
                            reset: {
                                text: Core.Definition.getDefinition('Réinitialiser'),
                                variant: 'light'
                            }
                        }"
                        :structure="formStructure">
                </CForm>
            </slot>
        </Request>
    </b-modal>
</template>

<script>
    import CForm from './CForm'
    import Request from './Request'
    export default {
        name: 'ModalExport',
        components: {
            CForm,
            Request
        },
        props: {
            root: {
                type: String,
                default: ''
            },
            method: {
                type: String,
                default: 'GET'
            },
            formStructure: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            }
        },
        computed: {
            open: {
                set(open) {
                    this.dataShow = open
                },
                get() {
                    return this.dataShow
                }
            }
        },
        watch: {
        },
        mounted() {
        },
        data: function () {
            return {
                Core: window.Core,
                dataId: '',
                dataSaveAddArgs: [],
                dataShow: false
            }
        },
        methods: {
            addSaveArg(key, value, type) {
                this.dataSaveAddArgs.push({
                    key: key,
                    value: value,
                    type: type
                })
            },
            onSubmit(form, fieldRefs, structure) {
                this.$refs.request.clearArgs()

                for(let key in form) {
                    let field = Core.Array.findByKey(this.formStructure.fields, 'id', key)
                    let value = form[key]
                    this.$refs.request.addArg(key, value, field.type)
                }

                this.$emit('onSubmit')

                this.$refs.request.addArg('exportFields', Core.Export.extractFields(form, this.formStructure.fields), Core.Value.typeJSON)
                this.$refs.request.request()
            },
            onReset() {

            },
            onRequestSuccess(data) {
                if (data.exportFile !== undefined) {
                    window.open(data.exportFile, '_blank');
                    this.open = false
                }
                this.$emit('onExportSuccess', data)
            }
        }
    }
</script>
